import {
    GETPAYMENTMODELIST_SUCCESS,
    GETPAYMENTMODELIST_FAILED,
    RESET_GETPAYMENTMODELIST,
    LOADING_GETPAYMENTMODELIST,
    NETWORK_ERROR_GETPAYMENTMODELIST,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetPaymentModeList = () => {
    return { type: RESET_GETPAYMENTMODELIST };
};

const getPaymentModeList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETPAYMENTMODELIST });
    await adminServices
        .post("getPaymentModeList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getPaymentModeListsuccess(res.data));
                    break;
                default:
                    dispatch(getPaymentModeListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETPAYMENTMODELIST, payload: err });
        });
};
function getPaymentModeListsuccess(data) {
    return {
        type: GETPAYMENTMODELIST_SUCCESS,
        payload: data,
    };
}
function getPaymentModeListFailed(data) {
    return {
        type: GETPAYMENTMODELIST_FAILED,
        payload: data,
    };
}

export { resetGetPaymentModeList, getPaymentModeList };
